import React from 'react';
import { templates } from './TemplateShowcase';

export default function TemplatePreview(){
  const params=new URLSearchParams(window.location.search);
  const id=params.get('template') || params.get('preview') || localStorage.getItem('ownezzy_preview_template');
  const t=templates.find(x=>x.id===id)||templates[0];
  return <div className="template-preview-page">
    <header className="preview-nav"><div className="preview-brand"><span>LS</span> Ownezzy</div><button className="btn btn-brand" onClick={()=>window.opener?window.close():window.history.back()}>Back to templates</button></header>
    <main>
      <section className={`preview-hero preview-${t.id}`}>
        <div className="preview-copy"><span>{t.emoji} {t.label}</span><h1>{t.name}</h1><p>{t.description}</p><button className="btn btn-light btn-lg" onClick={()=>window.opener?window.close():window.history.back()}>Use this template</button></div>
        <img src={t.image} alt={t.name}/>
      </section>
      <section className="preview-products"><div><small>STORE PREVIEW</small><h2>Designed to make your products stand out.</h2></div><div className="preview-product-grid">{['Featured collection','Best sellers','New arrivals'].map((x,i)=><div className="preview-product" key={x}><img src={t.image} alt=""/><strong>{x}</strong><span>Shop the collection</span></div>)}</div></section>
    </main>
  </div>
}
